import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import NotificationBox from '../../containers/form/NotificationBox'
import { fetchDiscussionSettings, saveDiscussionSettings } from 'components/discussion/discussionApi'
import { SettingsOption, SettingsSection } from './SettingsSection'

/** "Email me when someone replies" for lesson discussions. The reply emails link here. */
const DiscussionEmailSection = ({ id }: { id?: string }) => {
  const { t } = useTranslation('settings')
  const [replyEmails, setReplyEmails] = useState<boolean | null>(null)
  const [isUpdating, setIsUpdating] = useState(false)
  const [notify, setNotify] = useState({ label: '', isError: false })

  useEffect(() => {
    let alive = true
    fetchDiscussionSettings()
      .then((s) => alive && setReplyEmails(s.replyEmails))
      .catch(() => alive && setReplyEmails(true))
    return () => {
      alive = false
    }
  }, [])

  const clearNotify = () => setNotify({ label: '', isError: false })

  const handleToggle = async () => {
    if (isUpdating || replyEmails === null) return
    clearNotify()
    setIsUpdating(true)
    try {
      const saved = await saveDiscussionSettings(!replyEmails)
      setReplyEmails(saved.replyEmails)
      setNotify({ label: saved.replyEmails ? t('replyEmails.on') : t('replyEmails.off'), isError: false })
    } catch {
      setNotify({ label: t('replyEmails.saveError'), isError: true })
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <SettingsSection id={id} title={t('replyEmails.title')} note={t('replyEmails.note')}>
      <NotificationBox clearNotify={clearNotify} {...notify} />
      <div className='settings-options'>
        <SettingsOption
          type='checkbox'
          label={t('replyEmails.option')}
          checked={replyEmails !== false}
          disabled={isUpdating || replyEmails === null}
          onChange={handleToggle}
        />
      </div>
    </SettingsSection>
  )
}

export default DiscussionEmailSection
